import ls from "local-storage";

const PATIENT_QUEUE_TOKEN_KEY = "patient-queue-token";

const resetPatientQueueToken = () => {
  ls.remove(PATIENT_QUEUE_TOKEN_KEY);
};

const storePatientQueueToken = token => {
  ls(PATIENT_QUEUE_TOKEN_KEY, token);
};

const fetchPatientQueueToken = () => {
  return ls(PATIENT_QUEUE_TOKEN_KEY);
};

export {
  resetPatientQueueToken,
  storePatientQueueToken,
  fetchPatientQueueToken
};
